// フロントエンド用環境変数ユーティリティ

import { isEnabledEnv } from '@/class/common/util/env-util';

/**
 * IDH専用機能が有効か？
 * @returns true: 有効
 */
export function isEnvIdhInternal(): boolean {
  return isEnabledEnv( process.env.VUE_APP_IDH_INTERNAL );
}
